module.exports = __webpack_public_path__ + "static/img/question3-5.ad42ba6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/question3-5.png
// module id = clUA
// module chunks = 1